// Removes bundle offer gifts ("_bundle_gift" = parent product id) once the paid quantity of that product drops below
// the gift's "_bundle_unlock" quantity, e.g. when the lamp is removed from the cart.
const BundleGiftCart = {
  pending: null,

  init() {
    document.addEventListener('cart:change', (event) => this.reconcile(event.detail?.cart));
    this.fetchCart().then((cart) => this.reconcile(cart));
  },

  async fetchCart() {
    return (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
  },

  staleGiftKeys(cart) {
    const items = cart?.items ?? [];
    const paidQuantity = (productId) =>
      items
        .filter((item) => !item.properties?._bundle_gift && !item.properties?._free_gift)
        .filter((item) => String(item.product_id) === productId)
        .reduce((total, item) => total + item.quantity, 0);

    return items
      .filter((item) => item.properties?._bundle_gift)
      .filter((item) => paidQuantity(item.properties._bundle_gift) < Number(item.properties._bundle_unlock || 1))
      .map((item) => item.key);
  },

  async reconcile(cart) {
    if (!cart?.items || this.pending) return;

    const keys = this.staleGiftKeys(cart);
    if (!keys.length) return;

    this.pending = this.remove(keys);
    await this.pending;
    this.pending = null;
  },

  async remove(keys) {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }),
    );

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: Object.fromEntries(keys.map((key) => [key, 0])), sections }),
    });
    if (!response.ok) return;

    if (window.themeVariables?.settings?.pageType === 'cart') {
      window.location.reload();
      return;
    }

    // Not "variant:add": the drawer delays this swap 1250ms, so it lands after the swap still pending from the change
    // that triggered the removal (which holds the stale gift line)
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'bundle-gift:remove', cart: await response.json() },
      }),
    );
  },
};

if (!window.bundleGiftCartReady) {
  window.bundleGiftCartReady = true;
  BundleGiftCart.init();
}
